<template>
	<div v-if="open">
		<slot />
	</div>
</template>

<script>
// function copyStyles(sourceDoc, targetDoc) {
//   Array.from(sourceDoc.styleSheets).forEach(styleSheet => {
//     if (styleSheet.cssRules) {
//       // for <style> elements
//       const newStyleEl = sourceDoc.createElement("style");

//       Array.from(styleSheet.cssRules).forEach(cssRule => {
//         // write the text of each rule into the body of the style element
//         newStyleEl.appendChild(sourceDoc.createTextNode(cssRule.cssText));
//       });

//       targetDoc.head.appendChild(newStyleEl);
//     } else if (styleSheet.href) {
//       // for <link> elements loading CSS from a URL
//       const newLinkEl = sourceDoc.createElement("link");

//       newLinkEl.rel = "stylesheet";
//       newLinkEl.href = styleSheet.href;
//       targetDoc.head.appendChild(newLinkEl);
//     }
//   });
// }

import PrintCssRules from "./printRules";
export default {
	name: "print-window-portal",
	model: {
		prop: "open",
		event: "close"
	},
	props: {
		open: {
			type: Boolean,
			default: false
		},
		force_close: Number,
		windowFeatures: {
			type: String,
			default: "width=850,height=600"
		},
		layout: String
	},
	data() {
		return {
			windowRef: null
		};
	},
	watch: {
		open(newOpen) {
			if (newOpen) {
				this.openPortal();
			} else {
				this.closePortal();
			}
		},
		force_close(){
			this.closePortal();
		}
	},
	methods: {
		openPortal() {
			this.windowRef = window.open("", "", this.windowFeatures);
			this.windowRef.document.body.appendChild(this.$el);
			// copyStyles(window.document, this.windowRef.document);
			const newCss = document.createElement("style");
			newCss.innerHTML = PrintCssRules;
			// @media print{@page {size: landscape}}
			if (this.layout)
				newCss.innerHTML += `@media print{@page {size: A4 ${this.layout}}}`;
			this.windowRef.document.head.appendChild(newCss);

			const newLinkEl = document.createElement("link");
			newLinkEl.rel = "stylesheet";
			newLinkEl.href =
				"https://fonts.googleapis.com/css?family=Roboto:300,400,500,700,800,900";
			this.windowRef.document.head.appendChild(newLinkEl);

			this.windowRef.addEventListener("beforeunload", this.closePortal);
		},
		closePortal() {
			if (this.windowRef) {
				this.windowRef.close();
				this.windowRef = null;
				this.$emit("close");
			}
		}
	},
	mounted() {
		if (this.open) {
			this.openPortal();
		}
	},
	beforeDestroy() {
		if (this.windowRef) {
			this.closePortal();
		}
	}
};
</script>